export default __webpack_public_path__ + "static/media/Curses 3 - Node JS.b22c4747.png";